import React from 'react';
import { HelmetProvider, Helmet } from 'react-helmet-async';
import CookieConsent from './components/CookieConsent';
import Landing from './landing/Landing';

const SITE_URL = 'https://www.studiocorpoealma.com.br';
const DESCRIPTION =
  'Studio de Pilates em Pirituba e Freguesia do Ó, São Paulo. Aulas personalizadas, pilates para gestantes, pilates para idosos e mais. Agende sua aula experimental grátis!';

function App() {
  return (
    <HelmetProvider>
      <Helmet>
        <title>Studio Corpo & Alma - Pilates em Pirituba e Freguesia do Ó</title>
        <meta name="description" content={DESCRIPTION} />
        <meta
          name="keywords"
          content="pilates, pirituba, freguesia do ó, studio de pilates, pilates para gestantes, pilates para idosos, aula experimental grátis, saúde, bem-estar"
        />
        <meta property="og:title" content="Studio Corpo & Alma - Pilates em Pirituba e Freguesia do Ó" />
        <meta property="og:description" content={DESCRIPTION} />
        <meta property="og:type" content="website" />
        <meta property="og:url" content={SITE_URL} />
        <meta property="og:image" content={`${SITE_URL}/og-image.jpg`} />
        <meta property="og:locale" content="pt_BR" />
        <meta name="twitter:card" content="summary_large_image" />
        <link rel="canonical" href={SITE_URL} />
      </Helmet>

      <CookieConsent />
      <Landing />
    </HelmetProvider>
  );
}

export default App;
